var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 146,
    height: 155,
    viewBox: "0 0 146 155",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_56_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.42 0V14.09L134.23 42.27V65.29H146.43V35.22L85.42 0ZM134.23 89.7V112.72L85.42 140.9V154.99L146.43 119.76V89.69H134.23V89.7ZM12.21 89.7H0V119.77L61.01 155V140.91L12.2 112.73V89.71L12.21 89.7ZM0 35.23V65.3H12.2V42.28L61.01 14.09V0L0 35.23Z",
    fill: "url(#paint0_linear_56_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.42 126.82L97.62 119.77V83.03H109.82V112.72L122.02 105.68V49.32L109.82 42.27V70.83H97.62V35.23L85.42 28.19L73.22 21.15L61.02 28.19L48.82 35.23V70.83H36.62V42.27L24.42 49.32V105.68L36.62 112.72V83.03H48.82V119.77L61.02 126.82V42.27L73.22 35.23L85.42 42.27V126.82Z",
    fill: "url(#paint1_linear_56_2)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_56_2",
    x1: 40.69,
    y1: 8.68,
    x2: 106.01,
    y2: 146.88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#F8F9FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#ADB5BD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_56_2",
    x1: 49.34,
    y1: 28.12,
    x2: 94.51,
    y2: 121.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#F8F9FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#ADB5BD"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_56_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 146,
    height: 155,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.0001d302aea79186c9abfaa8c20a763c.svg";
export { ForwardRef as ReactComponent };